import styled from 'styled-components'
import {primary} from "../../assets/colorPallet";

export const StyledCheckboxContainer = styled.div`
  svg.MuiSvgIcon-root {
    color: ${primary};
  }
`

